var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _vm.filteredTickets.length > 0
      ? _c("div", { staticClass: "table-header" }, [
          _c("div", { staticClass: "table-header-cell round" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("Round")))]),
          ]),
          _c("div", { staticClass: "table-header-cell bet" }, [
            _vm._v(_vm._s(_vm.$t("Bet"))),
          ]),
          _c("div", { staticClass: "table-header-cell market" }),
          _c("div", { staticClass: "table-header-cell odds" }, [
            _vm._v(_vm._s(_vm.$t("Odds"))),
          ]),
          _c("div", { staticClass: "table-header-cell total" }, [
            _vm._v(_vm._s(_vm.$t("Total"))),
          ]),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "table-body" },
      [
        _vm._l(_vm.rows, function (ticket, index) {
          return [
            ticket.type === "general"
              ? _c(
                  "div",
                  {
                    key: `day-${ticket.dateVal}-${index}`,
                    staticClass: "day-divider",
                  },
                  [
                    _c("div", { staticClass: "day-divider__head" }, [
                      _c("div", { staticClass: "day-divider__date" }, [
                        _c("span", [_vm._v(_vm._s(ticket.date))]),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "day-divider__total",
                          class: _vm.signClass(_vm.dayTotal(ticket)),
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.currencySymbol) +
                              " " +
                              _vm._s(_vm.formatSigned(_vm.dayTotal(ticket))) +
                              " "
                          ),
                        ]
                      ),
                    ]),
                    _c("div", { staticClass: "day-divider__details" }, [
                      _c("div", { staticClass: "day-divider__item" }, [
                        _c("span", { staticClass: "day-divider__label" }, [
                          _vm._v(_vm._s(_vm.$t("Jackpot"))),
                        ]),
                        _c("span", { class: _vm.signClass(ticket.jackpot) }, [
                          _vm._v(
                            _vm._s(_vm.currencySymbol) +
                              " " +
                              _vm._s(_vm.formatAmount(ticket.jackpot, 2))
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "day-divider__item" }, [
                        _c("span", { staticClass: "day-divider__label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("Ante")) +
                              " (" +
                              _vm._s(_vm.taxPercent) +
                              "%)"
                          ),
                        ]),
                        _c("span", { staticClass: "lose" }, [
                          _vm._v(
                            _vm._s(_vm.currencySymbol) +
                              " -" +
                              _vm._s(_vm.formatAmount(ticket.ante, 2))
                          ),
                        ]),
                      ]),
                      _vm.isCreditUser || _vm.hasCommission
                        ? _c("div", { staticClass: "day-divider__item" }, [
                            _c("span", { staticClass: "day-divider__label" }, [
                              _vm._v(_vm._s(_vm.$t("Commission"))),
                            ]),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.currencySymbol) +
                                  " " +
                                  _vm._s(_vm.formatAmount(ticket.commission, 2))
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass:
                            "day-divider__item day-divider__item--end",
                        },
                        [
                          _c("span", { staticClass: "day-divider__label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.showEarnings ? _vm.$t("Earning") : "W/L"
                              )
                            ),
                          ]),
                          _c(
                            "span",
                            {
                              class: _vm.signClass(
                                _vm.showEarnings ? ticket.earnings : ticket.wl
                              ),
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.currencySymbol) +
                                  " " +
                                  _vm._s(
                                    _vm.formatSigned(
                                      _vm.showEarnings
                                        ? ticket.earnings
                                        : ticket.wl
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                )
              : _c(
                  "div",
                  {
                    key: `${ticket.id}-${index}`,
                    staticClass: "table-row",
                    class: {
                      even: ticket.stripe % 2 === 1,
                      "is-multi": _vm.isMulti(ticket),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.viewBetDetail(ticket)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "table-cell round" }, [
                      _c("span", { staticClass: "round__id" }, [
                        _vm._v(_vm._s(ticket.id)),
                      ]),
                      _c("span", { staticClass: "round__time" }, [
                        _vm._v(_vm._s(_vm.formatTime(ticket.date))),
                      ]),
                    ]),
                    _c("div", { staticClass: "table-cell bet" }, [
                      _vm._v(_vm._s(_vm.formatBetAmount(ticket.bet))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "table-cell market" },
                      [
                        _vm.isMulti(ticket)
                          ? _c(
                              "button",
                              {
                                staticClass: "bets-toggle",
                                class: { open: _vm.isExpanded(ticket) },
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.toggleExpanded(ticket)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.subTickets(ticket).length) +
                                    " " +
                                    _vm._s(_vm.$t("Bets")) +
                                    " "
                                ),
                                _c("span", {
                                  staticClass: "bets-toggle__caret",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            )
                          : _vm.iconMarket(ticket)
                          ? _c("TxMarketBadge", {
                              attrs: { market: _vm.iconMarket(ticket) },
                            })
                          : _c(
                              "span",
                              {
                                staticClass: "market-badge",
                                class: _vm.marketBadgeClass(ticket),
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.marketLabel(ticket)) + " "
                                ),
                              ]
                            ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "table-cell odds" }, [
                      _vm.isMulti(ticket)
                        ? _c("span", { staticClass: "odds-multi" }, [
                            _vm._v("—"),
                          ])
                        : Number(ticket.odds) !== 0
                        ? _c("span", [_vm._v(_vm._s(_vm.oddsText(ticket)))])
                        : _vm._e(),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "table-cell total",
                        class: _vm.totalClass(ticket),
                      },
                      [
                        _vm.isMulti(ticket) && _vm.isPending(ticket)
                          ? _c("span", { staticClass: "multi-status" }, [
                              _vm._v(" " + _vm._s(_vm.$t("Pending"))),
                              _c(
                                "span",
                                {
                                  staticClass: "multi-status__chevron",
                                  attrs: { "aria-hidden": "true" },
                                },
                                [_vm._v("›")]
                              ),
                            ])
                          : _vm.hasNumericTotal(ticket)
                          ? [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.formatSignedTotal(ticket)) +
                                  " "
                              ),
                            ]
                          : _c(
                              "span",
                              {
                                staticClass: "result-status",
                                class: {
                                  cancelled: ticket.raw.result === "cancelled",
                                  void: ticket.raw.result === "void",
                                  draw: ticket.raw.fight.result === "draw",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        _vm.$capitalize(
                                          ["cancelled", "void"].includes(
                                            ticket.raw.result
                                          )
                                            ? ticket.raw.result
                                            : [
                                                "processed",
                                                "processing",
                                              ].includes(
                                                ticket.raw.fight.status
                                              )
                                            ? ticket.raw.fight.result
                                            : ""
                                        )
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                      ],
                      2
                    ),
                  ]
                ),
            ticket.type !== "general" &&
            _vm.isMulti(ticket) &&
            _vm.isExpanded(ticket)
              ? _c(
                  "div",
                  {
                    key: `${ticket.raw.id}-subs-${index}`,
                    staticClass: "sub-rows",
                  },
                  _vm._l(_vm.subTickets(ticket), function (sub) {
                    return _c("div", { key: sub.id, staticClass: "sub-row" }, [
                      _c(
                        "div",
                        { staticClass: "sub-row__market" },
                        [
                          _vm.subIconMarket(sub)
                            ? _c("TxMarketBadge", {
                                attrs: { market: _vm.subIconMarket(sub) },
                              })
                            : _c(
                                "span",
                                {
                                  staticClass: "market-badge",
                                  class: _vm.marketBadgeClass(sub),
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.marketLabel(sub)) + " "
                                  ),
                                ]
                              ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "table-cell bet" }, [
                        _vm._v(
                          _vm._s(
                            sub.derived ? "—" : _vm.formatBetAmount(sub.amount)
                          )
                        ),
                      ]),
                      _c("div", { staticClass: "table-cell odds" }, [
                        _vm._v(_vm._s(_vm.subOddsText(sub))),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "table-cell total",
                          class: _vm.subIsPending(sub)
                            ? "pending"
                            : sub.derived
                            ? ""
                            : _vm.signClass(sub.winLossAmount),
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.subIsPending(sub)
                                  ? _vm.$t("Pending")
                                  : sub.derived
                                  ? "—"
                                  : _vm.formatSigned(Number(sub.winLossAmount))
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ])
                  }),
                  0
                )
              : _vm._e(),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }